import Spinner from '@/common-utils/components/renders/spinner/Spinner';
import ICONS from '../../../../../../enums/icons';
import { Button } from '../../../../../ui/button';
import {
    ModalClose,
    ModalFooter
} from '../../../../../ui/modal';
import PropTypes from 'prop-types';

const FooterConfirmation = ({
    onValidation,
    isSubmitDisabled,
    entityClose = 'button.no',
    entityValidate = 'button.yes',
    iconClose = ICONS.CLOSE,
    iconValidate = ICONS.VALIDATE
}) => {
    return (
        <ModalFooter>
            {isSubmitDisabled && <Spinner className='form-spinner' />}
            <ModalClose asChild>
                <Button
                    type='submit'
                    variant='secondary'
                    entity={entityClose}
                    icon={iconClose}
                    dataCy='modal-footer-close'
                />
            </ModalClose>
            <Button
                type='submit'
                variant='primary'
                entity={entityValidate}
                icon={iconValidate}
                onClick={onValidation}
                disabled={isSubmitDisabled}
                dataCy='modal-footer-submit'
            />
        </ModalFooter>
    );
};

FooterConfirmation.propTypes = {
    onValidation: PropTypes.func.isRequired,
    isSubmitDisabled: PropTypes.bool,
    entityClose: PropTypes.string,
    entityValidate: PropTypes.string,
    iconClose: PropTypes.string,
    iconValidate: PropTypes.string
};

export default FooterConfirmation;